import { Link as RouterLink } from 'react-router-dom'
import React from 'react'
const Link = React.forwardRef((props, ref) => {
  return (
    <RouterLink
      {...props}
      state={{
        ...props.state,
        canGoBack: true
      }}
    />
  )
})
export default Link
